import React from 'react';
import PropTypes from 'prop-types';
import conditionalComponent from './conditionalComponent';

/* eslint-disable object-shorthand,func-names */
export default conditionalComponent('HasErrors', {
  all: 'allHaveErrors',
  any: 'anyHaveErrors',
  propTypes: {
    errorKey: PropTypes.string.isRequired,
  },
  shouldRender: function (computedShouldRender) {
    let retval = computedShouldRender;

    if (computedShouldRender && this.props.errorKey) {
      retval = !!this.context.manager.requests.errorsFor(this.props.request || this.context.request).get(this.props.errorKey);
    }

    return retval;
  },
});
/* eslint-enable object-shorthand */



// WEBPACK FOOTER //
// ./app/javascript/requests/components/HasErrors.js